import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./NavbarNew.module.css";

interface NavbarProps {
  toggleMobileMenu?: () => void;
  isMobile?: boolean;
}

export default function Navbar({ toggleMobileMenu, isMobile = false }: NavbarProps) {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/songsterr-parser')) return 'Studio';
    if (path.includes('/songsv2')) return 'Songs Library';
    if (path.includes('/beats')) return 'Beats Library';
    if (path.includes('/song-requests')) return 'Song Requests';
    if (path.includes('/users')) return 'User Management';
    if (path.includes('/songs')) return 'Songs (Legacy)';
    if (path.includes('/about')) return 'About';
    return 'Drumly Sync Dashboard';
  };

  return (
    <header className={styles.navbar}>
      <div className={styles.navbarContent}>
        {/* Left: Hamburger + Page Title */}
        <div className={styles.navbarLeft}>
          {isMobile && (
            <button 
              className={styles.hamburgerButton}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <span className={styles.hamburgerIcon}>☰</span>
            </button>
          )}
          <h2 className={styles.pageTitle}>{getPageTitle()}</h2>
        </div>

        {/* Right: Search + Status + Help */}
        <div className={styles.navbarRight}>
          {/* Search Bar (optional - can be enabled per page) */}
          {location.pathname.includes('/songsv2') && (
            <div className={styles.searchContainer}>
              <input
                type="text"
                placeholder="Search songs..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={styles.searchInput}
              />
            </div>
          )}

          {/* Status Pill */}
          {location.pathname.includes('/songsterr-parser') && (
            <div className="status-pill">
              <span>Ready</span>
            </div>
          )}

          {/* Help Icon */}
          <button className={styles.iconButton} title="Help">
            <span role="img" aria-label="help">❓</span>
          </button>
        </div>
      </div>
    </header>
  );
}
